import { TimePool } from '@/utils/timer';
import { getJsDateObject, parseTime } from '@/utils/index';

const delay = 1000;
const interval = new TimePool().getTimer(delay);

class CountDown {
  constructor(option) {
    if (!option.endTime) {
      new Error('end time must be passed to count down');
    }
    const defaultOption = {
      startTime: new Date().valueOf(),
      endTime: new Date().valueOf() + (1000 * 60),
      render(output) {
        console.log('output', output); // eslint-disable-line no-console
      },
      end() {
        console.log('end'); // eslint-disable-line no-console
      },
    };
    Object.keys(defaultOption).forEach((key) => {
      if (key === 'startTime' || key === 'endTime') {
        option[key] = option[key] ? getJsDateObject(option[key]).valueOf() : 0;
      }
      this[key] = option[key] || defaultOption[key];
    });
    this.init();
  }

  getBetween() {
    return this.endTime - this.startTime;
  }

  init() {
    const index = interval.add(() => {
      this.startTime += delay;
      if (this.startTime >= this.endTime) {
        interval.remove(index);
        this.end();
        return;
      }
      this.render(parseTime(this.getBetween()));
    });
  }
}

export default CountDown;
